import React, { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { api, API, apiError } from "@/lib/api";
import { toast } from "sonner";

// Reusable uploader. Calls onUploaded({id, url, absoluteUrl, content_type, original_filename, category}).
export function FileUpload({
  category = "general",
  refId = "",
  accept = "image/*,video/*",
  label = "Upload file",
  className = "",
  testId = "file-upload",
  onUploaded,
}) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => inputRef.current?.click();

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("category", category);
      fd.append("ref_id", refId || "");
      const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const absoluteUrl = `${API}/files/${data.id}`;
      onUploaded?.({ ...data, absoluteUrl });
      toast.success("Uploaded");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept={accept} onChange={handle} className="hidden" data-testid={`${testId}-input`} />
      <button type="button" onClick={pick} disabled={busy} data-testid={`${testId}-btn`}
        className={`btn-ghost rounded-lg h-9 px-3 text-sm flex items-center gap-2 disabled:opacity-60 ${className}`}>
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />} {busy ? "Uploading…" : label}
      </button>
    </>
  );
}
